
import {
  Vue,
  Component,
  Prop,
  Watch,
  Model,
  Ref,
} from 'vue-property-decorator';

import lazyInject from '@/di';
import CarService from '@/services/car.service';
import VinModelComponent from './VinModelComponent.vue';

@Component({
  components: {
    VinModelComponent,
  },
  name: 'VinCodeField',
})
export default class VinCodeField extends Vue {
  val = '';

  modalList: any[] = [];

  @Prop()
  readonly!: boolean;

  @Prop()
  shopId!: any;

  @Prop()
  disabled!: boolean;

  @Prop()
  placeholder!: string;

  @lazyInject(CarService)
  carService!: CarService;

  @Ref('vinModelComponent')
  vinModelComponent!: VinModelComponent;

  @Model('change', {
    type: String,
  })
  value!: string;

  @Watch('val')
  watchVal() {
    this.$emit('update', this.val);
  }

  @Watch('value')
  watchValue() {
    if (this.value) {
      this.val = `${this.value}`;
    } else {
      this.val = '';
    }
  }

  mounted() {
    this.watchValue();
  }

  getVinModal() {
    console.log(this.val);
    if (this.val && this.val.length === 17) {
      this.getFunVinModel(this.val);
    }
  }

  async getFunVinModel(vin: string) {
    const foDate = {
        brand: '',
        brandId: '',
        gearName: '',
        liter: '',
        modelName: '',
        modelId: '',
        official_price: '',
        series: '',
        seriesId: '',
      };
    this.checkedVin(foDate);
    const res = await this.carService.getVinModel({ vin, from: 'dyh-manage', shop_id: this.shopId });
    // console.log(res);
    if (res.length > 1) {
      this.modalList = res;
      this.vinModelComponent.init();
    } else if (res.length === 1) {
      // console.log(res[0]);
      const {
        brand,
        brand_id,
        gear_name,
        id,
        liter,
        model_name,
        official_price,
        series,
        series_id,
      } = res[0];
      const formDate = {
        brand,
        brandId: brand_id,
        gearName: gear_name,
        liter,
        modelName: model_name,
        modelId: id,
        official_price: Number(official_price) / 10000,
        series,
        seriesId: series_id,
      };
      this.checkedVin(formDate);
    }
  }

  checkedVin(vin: any) {
    // this.val = vin;
    console.log(vin);
    this.$emit('vinModel', vin);
    this.$emit('brandCarSeriesModels', vin);
  }
}
